import React from "react";
import ListenIcon from "../../../../assets/icons/listenicon";
import "./listen-button.m.css";

export const ListenButton = ({ className, onClick }) => {
    return (
        <div 
            className={`${className || ""} trinity-tts-icon-player-button-wrapper`} 
            styleName="custom-listen-button"
            data-player-id="trinity-audio-player"
            onClick={onClick} 
        >
            <ListenIcon width={24} height={24} color="currentColor" />
            <span>Listen</span>
        </div>
    );
};

export default ListenButton;
